import { apiClient } from '@/lib/api-client';
import { API_ENDPOINTS, NotificationPreferences, NotificationPreferencesUpdate } from '@/types/api';

export const notificationsApi = {
  // Get current user's notification preferences
  getPreferences: async (): Promise<NotificationPreferences> => {
    return apiClient.get<NotificationPreferences>(API_ENDPOINTS.notifications.preferences);
  },
  
  // Update notification preferences (partial update)
  updatePreferences: async (data: NotificationPreferencesUpdate): Promise<NotificationPreferences> => {
    return apiClient.patch<NotificationPreferences>(API_ENDPOINTS.notifications.preferences, data);
  },
};

